module.exports = {
    language: {
        title: '選擇您的語言<br/>(Choose your language)',
        lang:'中文繁體'
    },
    start:{
        startText:'獅子餓了!<br/>一起餵養吧。',
        startButton:'開始餵養',
        openTip:'為了更好的遊戲體驗，請到設定->Safari->隱私權和安全性，開啟【動作與方向取用】。',
        toBrowser:'請點擊右上方的按鈕，在瀏覽器開啟Wenno AR遊戲，體驗餵食動物的快樂吧！',
        example:'例如'
    },
    game:{
        resultText:'恭喜你成為',
        saveBtn:'截圖保存',
        press:'長按圖片可以直接傳送給朋友，或先儲存圖片到手機再分享朋友圈。',
        trainer:'馴獸師'
    },
    animals:{
        lion:'獅子',
    },
    loading:{
        tipsText0:'用手指滑動屏幕，點擊動物喜歡吃的食物，它就會越來越喜歡你。',
        tipsText1:'舉起手機，左右移動，點擊動物喜歡吃的食物，它就會越來越喜歡你。',
        tipsTitle:'玩法提示',
        load:'加載中'
    },
    success:{
        successText:'成功餵養',
        text:'恭喜你成為',
        otherText:'挑戰其他動物',
        continueTitle:'繼續遊戲',
        playAgain:'再玩一次',
        understandTitle:'了解更多',
        downloadTitle:'下载',
        trainer:'馴獸師',
        apple:'蘋果商店',
        google:'谷歌商店',
        xiaomi:'小米商店',
        huawei:'華為商店'
    }
    

}


// WEBPACK FOOTER //
// ./src/assets/common/lang/hk.js